import { FormType } from '@aloft/toolkit-shared';
import { Block, CheckboxGroup, SimpleSelect } from '@aloft/toolkit-sui';

export const ExportModalSelectFormType = ({
  formType,
  setFormType,
  options,
  includeAnnotations,
  setIncludeAnnotations,
}: {
  formType: FormType;
  setFormType: (val: FormType) => void;
  includeAnnotations?: boolean;
  setIncludeAnnotations?: (val: boolean) => void;
  options: { label: string; value: FormType }[];
}) => (
  <Block marginTop="1rem" width="100%">
    <SimpleSelect
      label="Form Type"
      value={formType}
      onChange={(e) => setFormType(e.target.value as FormType)}
      width="100%"
    >
      {options.map(({ value, label }) => (
        <option key={`option-${value}`} value={value}>
          {label}
        </option>
      ))}
    </SimpleSelect>
    {setIncludeAnnotations && (
      <Block marginTop="1rem">
        <CheckboxGroup
          size="sm"
          label=""
          value={includeAnnotations ? ['includeAnnotations'] : []}
          items={[
            {
              label: 'Update property features in your sales grid (optional)',
              value: 'includeAnnotations',
            },
          ]}
          onChange={(e) => setIncludeAnnotations(e.includes('includeAnnotations'))}
        />
      </Block>
    )}
  </Block>
);
